<template>
	<div class="flex flex-row text-left gap-3">
		<div class="flex flex-col items-center">
			<span class="text-tiny font-semibold">{{ title }}</span>
			<span class="font-bold text-5xl">{{ Number(statistics.avg || 0).toFixed(1) }}</span>
			<div class="flex flex-row">
				<div class="flex flex-row" v-for="i in 10" :key="i">
					<app-icon v-if="statistics.avg >= i" class="text-primary" icon="star" />
					<app-icon
						v-if="statistics.avg > i && statistics.avg < i + 1"
						class="text-primary"
						icon="star-half"
					/>
					<app-icon v-if="statistics.avg <= i - 1" class="text-primary" icon="star-empty" />
				</div>
			</div>
			<span class="text-tiny text-gray-800">{{ statistics.rateAll }} {{ $t('Reviews') }}</span>
		</div>
		<div v-if="renderFilters" class="flex flex-col-reverse items-center ">
			<div v-for="(value, key) in rateOptions" :key="key" class="flex flex-row items-center gap-3">
				<span class="text-tiny">{{ key + 1 }}</span>
				<app-tooltip class="w-48" :text="`${value} reviews`">
					<div class="w-full h-1 bg-gray-200 rounded-lg">
						<div class="rounded-lg h-1 bg-primary" :style="`width: ${getBarWidth(value)}%;`"></div>
					</div>
				</app-tooltip>
			</div>
		</div>
	</div>
</template>

<script>
	import AppIcon from '@/components/app/AppIcon';
	import AppTooltip from '@/components/app/AppTooltip';

	export default {
		name: 'AppRatesCard',
		components: { AppTooltip, AppIcon },
		data: () => ({
			rateOptions: [],
			renderFilters: true,
		}),
		props: {
			statistics: {},
			title: {},
		},
		methods: {
			reRenderFilters() {
				this.renderFilters = false;
				this.$nextTick(() => {
					this.renderFilters = true;
				});
			},
			getBarWidth(rate) {
				return this.statistics.rateAll === 0 ? 0 : (rate / this.statistics.rateAll) * 100;
			},
			getRateOptions() {
				this.rateOptions = [];
				this.rateOptions.push(
					this.statistics.rate1,
					this.statistics.rate2,
					this.statistics.rate3,
					this.statistics.rate4,
					this.statistics.rate5,
					this.statistics.rate6,
					this.statistics.rate7,
					this.statistics.rate8,
					this.statistics.rate9,
					this.statistics.rate10
				);
			},
		},
		watch: {
			statistics: {
				handler() {
					this.getRateOptions();
					this.reRenderFilters();
				},
				deep: true,
			},
		},
	};
</script>

<style scoped></style>
